export var originalWindow = typeof window === "undefined" ? undefined : window;
export var originalGlobalThis =
  typeof globalThis === "undefined" ? undefined : globalThis;
